/**
 * micro:bit 아이콘 40개 — 5×5 켜짐(1) · 꺼짐(0)을 가로로 이은 25글자. 출처: MakeCode pxt-microbit `IconNames`(MIT · Microsoft).
 * 놀이터가 보드 화면이 어떤 아이콘인지 알아본다(PICNIC-MB-FIELD-001 통로 ① 화면 읽기). 이름(한국어)은 i18n `student.microbit.icon.<이름>`.
 */
export const ICONS: Readonly<Record<string, string>> = {
  Angry: "1000101010000001111110101",
  Asleep: "0000011011000000111000000",
  Butterfly: "1101111111001001111111011",
  Chessboard: "0101010101010101010101010",
  Confused: "0000001010000000101010101",
  Cow: "1000110001111110111000100",
  Diamond: "0010001010100010101000100",
  Duck: "0110011100011110111000000",
  EighthNote: "0010000110001011110011100",
  Fabulous: "1111111011000000101001110",
  Ghost: "0111010101111111111110101",
  Giraffe: "1100001000010000111001010",
  Happy: "0000001010000001000101110",
  Heart: "0101011111111110111000100",
  House: "0010001110111110111001010",
  LeftTriangle: "1000011000101001001011111",
  Meh: "1101100000000100010001000",
  No: "1000101010001000101010001",
  Pitchfork: "1010110101111110010000100",
  QuarterNote: "0010000100001001110011100",
  Rabbit: "1010010100111101101011110",
  Rollerskate: "0001100011111111111101010",
  Sad: "0000001010000000111010001",
  Scissors: "1100111010001001101011001",
  Silly: "1000100000111110001100011",
  Skull: "0111010101111110111001110",
  SmallDiamond: "0000000100010100010000000",
  SmallHeart: "0000001010011100010000000",
  SmallSquare: "0000001110010100111000000",
  Snake: "1100011011010100111000000",
  Square: "1111110001100011000111111",
  StickFigure: "0010011111001000101010001",
  Surprised: "0101000000001000101000100",
  Sword: "0010000100001000111000100",
  TShirt: "1101111111011100111001110",
  Target: "0010001110110110111000100",
  Tortoise: "0000001110111110101000000",
  Triangle: "0000000100010101111100000",
  Umbrella: "0111011111001001010011100",
  Yes: "0000000001000101010001000",
};
